import type {
  InheritedMember
} from '../../../../service/workspaceMembers.service';
import type UserType from './type';

/** Inherited people as table rows, minus anyone already listed and anyone the search excludes. */
export const buildInheritedRows = (
  members: InheritedMember[],
  listedIds: Iterable<string | number>,
  search: string,
  manageable: boolean
): UserType[] => {
  const needle = search.trim().toLowerCase();
  const serverIds = new Set(listedIds);
  return members
    .filter((m) => !serverIds.has(m.user_id))
    .filter((m) => !needle || [m.email, m.first_name, m.last_name]
      .some((part) => (part ?? '').toLowerCase().includes(needle)))
    .map((m) => ({
      id: m.user_id,
      email: m.email,
      firstName: m.first_name ?? '',
      lastName: m.last_name ?? '',
      enabled: true,
      roles: [m.role],
      memberships: [{
        node_id: m.source_node_id ?? -1,
        node_kind: m.source_node_kind,
        node_name: m.source_node_name ?? 'an administrator above',
        role: m.role
      }],
      inherited: {
        from: m.source_node_kind,
        nodeName: m.source_node_name,
        sourceNodeId: m.source_node_id,
        manageable
      }
    } as unknown as UserType));
};
